import React, { Component } from "react";
// import thunk from "redux-thunk";
import { Provider } from "react-redux";
// import { applyMiddleware, createStore } from "redux";
import "./utils/axiosSetup"; 
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import Routes from "./Routes";
import { isLoggedIn } from "./utils/Authentication";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import store from "./redux/store";
import "spinners-react/lib/SpinnerCircular.css";
import "spinners-react/lib/index.css";
// import reducers from "./components/pages/login/reducers/loginComponent";

// const middleware = applyMiddleware(thunk);
// const initialState = window.INITIAL_STATE;
// const store = createStore(reducers, initialState, middleware);

const BILLING_POPUP_KEY = "shopify_billing_popup";
const BILLING_POPUP_TTL_MS = 15 * 60 * 1000;

class App extends Component {
  state = {
    closingShopifyPopup: false,
    shopifyPopupMessage: "",
  };

  componentDidMount() {
    function verifyUser(userInfo) {
      return {
        type: 'TOKEN_VERIFIED',
        payload: userInfo
      }
    }
    store.dispatch(verifyUser(isLoggedIn()));
    this.closeShopifyPopupIfNeeded();
  }

  hasPendingBillingPopup = () => {
    try {
      const ts = Number(localStorage.getItem(BILLING_POPUP_KEY) || 0);
      return ts > 0 && Date.now() - ts < BILLING_POPUP_TTL_MS;
    } catch (e) {
      return false;
    }
  };

  clearPendingBillingPopup = () => {
    try {
      localStorage.removeItem(BILLING_POPUP_KEY);
    } catch (e) {}
  };

  closeShopifyPopupIfNeeded = () => {
    const popupName = window.name;
    const params = new URLSearchParams(window.location.search);
    const shopifyReturn =
      params.has("hmac") ||
      params.has("host") ||
      params.has("charge_id") ||
      !!params.get("billing");
    const path = window.location.pathname || "/";
    const onPublicReturnPage =
      path === "/" ||
      path === "/home" ||
      path === "/login" ||
      path === "/appinstall";

    const pendingBilling = this.hasPendingBillingPopup();

    // Same-tab /shopify-configuration flow must never be treated as profile popup
    let fromConfig = false;
    try {
      fromConfig = sessionStorage.getItem("shopifyInstallSource") === "config";
    } catch (e) {}

    // Billing popup: close when Shopify returns with billing/hmac params
    const isBillingPopup =
      shopifyReturn &&
      onPublicReturnPage &&
      (popupName === "shopifyBilling" || pendingBilling);

    // Profile Complete App Setup popup (named window)
    const isAppInstallPage =
      path === "/appinstall" && popupName === "shopifyAppSetup";

    // When Shopify returns into the named setup popup on public pages,
    // close it — but never for same-tab config install flow.
    const isSetupPopupReturn =
      !fromConfig &&
      popupName === "shopifyAppSetup" &&
      shopifyReturn &&
      onPublicReturnPage;

    if (!isBillingPopup && !isAppInstallPage && !isSetupPopupReturn) return;

    const isBilling = isBillingPopup;
    const messageType = isBilling
      ? "SHOPIFY_BILLING_DONE"
      : "SHOPIFY_APP_INSTALLED";

    if (isBilling) this.clearPendingBillingPopup();

    try {
      sessionStorage.removeItem("shopifyInstallSource");
    } catch (e) {}

    try {
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(
          { type: messageType, status: "success" },
          "*",
        );
      }
    } catch (e) {}

    this.setState({
      closingShopifyPopup: true,
      shopifyPopupMessage: isBilling
        ? "Subscription completed successfully!"
        : "App setup completed successfully!",
    });

    setTimeout(() => {
      try {
        window.close();
      } catch (e) {}
    }, 2000);
  };

  render() {
    if (this.state.closingShopifyPopup) {
      return (
        <div
          style={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            fontFamily: "Arial",
            background: "#f9f9f9",
            padding: 24,
          }}
        >
          <h2 style={{ marginBottom: 12 }}>{this.state.shopifyPopupMessage}</h2>
          <p>This window will close automatically...</p>
        </div>
      );
    }

    return (
      <div>
        <Provider store={store}>
          <Router>{Routes}</Router>
        </Provider>
        <ToastContainer hideProgressBar />
      </div>
    );
  }
}

export default App;
